import { useMediaQuery, useTheme } from "@material-ui/core";
import CallMadeRoundedIcon from "@mui/icons-material/CallMadeRounded";
import { getMentorBadgeDetails } from "../../../../utils/constants";
import { DESKTOP_BREAKPOINT } from "../../consts";
import { badgeInfo } from "../../consts";
import { useHeaderStyles } from "./styles";
import { EditDetailsButton } from "../EditDetailsButton/EditDetailsButton";

import defaultProfile from "../../../../assets/images/mentor_profile/default_profile.png";
import scheduleIcon from "../../../../assets/images/mentor_profile/schedule.png";
import languagesIcon from "../../../../assets/images/mentor_profile/languages.png";
import codingIcon from "../../../../assets/images/mentor_profile/coding.png";
import englishIcon from "../../../../assets/images/mentor_profile/english.png";
import scienceIcon from "../../../../assets/images/mentor_profile/science.png";
import mathIcon from "../../../../assets/images/mentor_profile/math.png";

const subjectIconMap = {
  Coding: codingIcon,
  English: englishIcon,
  Science: scienceIcon,
  Math: mathIcon,
};

const ViewProfileButton = ({ onClick, classes }) => (
  <button className={classes.nameActionBtn} onClick={onClick}>
    View profile <CallMadeRoundedIcon className={classes.nameActionIcon} />
  </button>
);

export const Header = ({
  profileData = {},
  languages = [],
  subjects = [],
  isPublicProfile = false,
  onViewProfile,
  onOpenEdit,
}) => {
  const classes = useHeaderStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(DESKTOP_BREAKPOINT));

  const {
    FNAME: firstName = "",
    LNAME: lastName = "",
    photo,
    totalYears = "",
    badgeId,
  } = profileData;

  const fullName = `${firstName} ${lastName}`.trim() || "Name not available";
  const badgeDetails = getMentorBadgeDetails(badgeId);
  const badgeInfoData = badgeInfo[badgeId] || badgeInfo[false];

  const languagesText = languages?.length
    ? languages
      .map((l) => (typeof l === "string" ? l : l?.language))
      .filter(Boolean)
      .join(", ")
    : "English";

  const experienceText = totalYears || "N/A";

  return (
    <div className={classes.headerWrapper}>
      <div className={classes.headerBgWrapper}>
        <div className={classes.headerContent}>
          <div className={classes.profileSection}>
            <div className={classes.profileImageWrapper}>
              <img
                src={photo || defaultProfile}
                alt={fullName}
                className={classes.profileImg}
              />
            </div>

            <div className={classes.profileDetails}>
              <div className={classes.nameRow}>
                <div className={classes.mentorName}>{fullName}</div>

                {!isMobile && !isPublicProfile && (
                  <div className={classes.nameActions}>
                    <ViewProfileButton
                      onClick={onViewProfile}
                      classes={classes}
                    />
                  </div>
                )}
              </div>

              {/* Desktop: subjects inline */}
              <div className={classes.subjectsRow}>
                <span className={classes.subjectsLabel}>
                  What kids are learning from me:
                </span>
                <div className={classes.subjectsChips}>
                  {subjects &&
                    subjects.length > 0 &&
                    subjects.map((subjectName) => (
                      <span key={subjectName} className={classes.subjectChip}>
                        {subjectIconMap[subjectName] && (
                          <img
                            src={subjectIconMap[subjectName]}
                            alt={subjectName}
                          />
                        )}
                        {subjectName}
                      </span>
                    ))}
                </div>
              </div>

              <div className={classes.infoRow}>
                <div className={classes.infoItem}>
                  <img src={scheduleIcon} alt="experience" />
                  <span className={classes.infoItemText}>
                    I'm teaching since {experienceText} years
                  </span>
                </div>
                <div className={classes.infoItem}>
                  <img src={languagesIcon} alt="languages" />
                  <span className={classes.infoItemText}>
                    I can speak in {languagesText}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Desktop badge */}
          {badgeId && !isMobile && (
            <div className={classes.badgeSection}>
              <img
                src={badgeDetails?.badgeImg}
                alt={badgeDetails?.name}
                className={classes.badgeImage}
              />
            </div>
          )}
        </div>

        {/* Mobile: subjects section below header bg */}
        <div className={classes.mobileSubjectsSection}>
          <div className={classes.mobileSubjectsLabel}>
            What kids are learning from me:
          </div>
          <div className={classes.mobileSubjectsChips}>
            {subjects &&
              subjects.length > 0 &&
              subjects.map((subjectName) => (
                <span key={subjectName} className={classes.subjectChip}>
                  {subjectIconMap[subjectName] && (
                    <img src={subjectIconMap[subjectName]} alt={subjectName} />
                  )}
                  {subjectName}
                </span>
              ))}
          </div>
        </div>
      </div>
      {isMobile && !isPublicProfile && (
        <div className={classes.nameActions}>
          <ViewProfileButton onClick={onViewProfile} classes={classes} />
          {onOpenEdit && (
            <EditDetailsButton
              onEditProfile={onOpenEdit}
              className={classes.editDetailsBtn}
              wrapperClassName={classes.editDetailsBtnWrapper}
            />
          )}
        </div>
      )}

      {/* Mobile: badge milestone section */}
      {badgeId && (
        <div className={classes.mobileBadgeSection}>
          <img
            src={badgeDetails?.badgeImg}
            alt={badgeDetails?.name}
            className={classes.mobileBadgeImg}
          />
          <div className={classes.mobileBadgeText}>
            Completed{" "}
            <div className={classes.mobileBadgeTextStrong}>
              {badgeInfoData?.teachingHours}+ hours
            </div>{" "}
            teaching with Codeyoung
          </div>
        </div>
      )}
    </div>
  );
};
